/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { Text } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';

interface UsageCellProps {
  usage: number;
}

const UsageCell: React.FC<UsageCellProps> = ({ usage }) => {
  const { t } = useTranslation('administration');
  const usageCount = usage || 0;
  return (
    <Text fontSize="14px" color="#6B7280">
      {t('questionnaireTemplate.usage', { count: usageCount })}
    </Text>
  );
};

export default UsageCell;
